export function getAddressId(address) {
  if (!address || typeof address !== "object") return null;
  return address.id ?? address.address_id ?? null;
}

export function addressIdEquals(left, right) {
  if (left == null || right == null) return false;
  return String(left) === String(right);
}

export function isDefaultAddressFlag(value) {
  return value === true || value === 1 || value === "1";
}

export function isAddressDefault(address) {
  return isDefaultAddressFlag(address?.is_default);
}